export default __webpack_public_path__ + "static/media/flag-somalia.d2a49b5e.svg";